// extracted by mini-css-extract-plugin
module.exports = {"noticeWrap":"AuthenticationModal_style_noticeWrap__bfQOJ","content":"AuthenticationModal_style_content__5LCkY"};